import EditButtonProduct from './EditButtonProduct';

export default EditButtonProduct;
